var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0373 8.60415L10.7339 8.90615C10.7339 8.90615 10.0119 9.62348 8.04192 7.66482C6.07192 5.70615 6.79392 4.98882 6.79392 4.98882L6.98459 4.79815C7.45592 4.33015 7.50059 3.57815 7.08925 3.02882L6.24925 1.90682C5.73992 1.22682 4.75659 1.13682 4.17325 1.71682L3.12659 2.75682C2.83792 3.04482 2.64459 3.41682 2.66792 3.83015C2.72792 4.88815 3.20659 7.16348 5.87592 9.81815C8.70725 12.6328 11.3639 12.7448 12.4499 12.6435C12.7939 12.6115 13.0926 12.4368 13.3333 12.1968L14.2799 11.2555C14.9199 10.6201 14.7399 9.53015 13.9213 9.08548L12.6479 8.39282C12.1106 8.10148 11.4573 8.18682 11.0373 8.60415Z",
    fill: "#89D55B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.0f9be9d52b2d4da31d32879258539ad7.svg";
export { ForwardRef as ReactComponent };